// extracted by mini-css-extract-plugin
export default {"getNotified":"GetNotified_getNotified__Y4UEt","dialog":"GetNotified_dialog__B6ISW","content":"GetNotified_content__w+k8B"};